import createMuiTheme from 'material-ui/styles/createMuiTheme';
import * as STYLE from './UIConstants';
 
export const theme = createMuiTheme({
    'palette': {
        'secondary': {
            '50': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            '100': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            '200': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            '300': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            '400': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            '500': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            '600': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            '700': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            '800': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            '900': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            'A100': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            'A200': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            'A400': STYLE.CONSTANTS.COLORS.THEME_BLUE,
            'A700': STYLE.CONSTANTS.COLORS.THEME_BLUE,
        }
    }
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/Theme.ts